import React, { useState, useEffect } from 'react';
import {
  CheckCircleIcon,
  SearchIcon,
  TrashIcon,
} from '@heroicons/react/outline';

import DefaultLayout from '../../components/layout/DefaultLayout';
import hielocosService from '../../services/hielocos';
import {
  fetchHielocos,
  fetchHielocosNextPage,
} from '../../store/actions/hielocos';
import { useDispatch, useSelector } from 'react-redux';
import { Input, notification, Popconfirm } from 'antd';
import debounceAsync from '../../helpers/debounce';
import HielocoSkeleton from '../../components/hielocos/hieloco-skeleton';
import { Ghost } from 'react-kawaii';
import Hieloco from '../../components/hielocos/hieloco';
import InfiniteScroll from 'react-infinite-scroll-component';
import CreateHieloco from '../../components/hielocos/create-hieloco';
import { deleteHieloco as deleteHielocoAction } from '../../store/actions/hielocos';

const HielocosScreen = () => {
  const dispatch = useDispatch();
  const { items, loading, currentPage, totalPages } = useSelector(
    (state) => state.hielocos
  );
  const [filteredHielocos, setFilteredHielocos] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(fetchHielocos());
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    searchHieloco(search);
    // eslint-disable-next-line
  }, [search, items]);

  async function searchHieloco(search) {
    if (!search) return setFilteredHielocos(items);

    const beginSearch = async () => {
      let filtered = [];
      filtered = items.filter((hieloco) => {
        const name = hieloco.name.toLowerCase();

        return name.indexOf(search.toLocaleLowerCase()) > -1;
      });

      if (filtered.length === 0) {
        const { items } = await hielocosService.search(search);

        filtered = items;
      }

      return filtered;
    };

    const filteredHielocos = await debounceAsync(beginSearch);

    setFilteredHielocos(filteredHielocos);
  }

  const deleteHieloco = async (hieloco) => {
    try {
      const res = await dispatch(deleteHielocoAction(hieloco.id));

      notification.open({ type: 'success', message: res.message, placement: 'bottomRight'});
    } catch (error) {}
  };

  return (
    <DefaultLayout>
      <div className="p-10">
        <h1 className="text-3xl lg:text-4xl font-bold">Poaps</h1>

        <div className="mt-2 lg:flex justify-between">
          <CreateHieloco />

          <Input
            placeholder="Buscar por descripción"
            size="large"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            suffix={
              <SearchIcon width={24} className="text-black text-opacity-30" />
            }
            className="lg:w-96"
          />
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 my-10">
            <HielocoSkeleton cols={filteredHielocos.length} />
          </div>
        ) : (
          <div>
            {filteredHielocos.length === 0 && (
              <div className="w-full h-96 flex flex-col justify-center items-center text-black text-opacity-50">
                <Ghost size={150} mood="sad" color="#d7d8d8a7" />

                <p className="text-2xl mt-2">No se encontraron poaps</p>
                <p>Los poaps creados se mostraran aqui.</p>
              </div>
            )}

            <InfiniteScroll
              dataLength={filteredHielocos.length}
              next={() => {
                if (loading) return;
                dispatch(fetchHielocosNextPage(currentPage));
              }}
              hasMore={currentPage < totalPages}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 my-10"
              style={{ overflow: 'visible' }}
              endMessage={
                filteredHielocos.length > 20 && (
                  <div className="md:col-span-2 lg:col-span-3">
                    <div className="text-center text-black text-opacity-60">
                      <div className="flex items-center justify-center">
                        <CheckCircleIcon width={40} />
                      </div>
                      <h4 className="font-medium">
                        No se encontrarón mas resultados
                      </h4>
                    </div>
                  </div>
                )
              }
            >
              {filteredHielocos.map((hieloco) => (
                <Hieloco
                  hieloco={hieloco}
                  key={hieloco.id}
                  menu={
                    <Popconfirm
                      title="Esta seguro que desea eliminar el poap?"
                      onConfirm={() => deleteHieloco(hieloco)}
                      okText="Eliminar"
                      cancelText="Cancelar"
                      placement="top"
                    >
                      <TrashIcon width={18} />
                    </Popconfirm>
                  }
                />
              ))}
            </InfiniteScroll>
          </div>
        )}
      </div>
    </DefaultLayout>
  );
};

export default HielocosScreen;
